import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const freeagent = defineConnector({
  identifier: "freeagent",
  name: "FreeAgent",
  tagLine: "Accounting software for small businesses",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.freeagent\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a FreeAgent app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [FreeAgent app registration docs](https://dev.freeagent.com/docs/introduction#registering-your-application) and create a new application in the FreeAgent developer portal. Copy the client ID and client secret for the app.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/freeagent/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your FreeAgent account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your FreeAgent account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.freeagent.com/v2/approve_app",
    tokenEndpoint: () => "https://api.freeagent.com/v2/token_endpoint",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.freeagent.com/",
  },
});
